import AppOrderpositionsIndex from "./orderPositions.vue";
import AppOrderpositionsList from "./list/list.vue";
import AppOrderpositionsItem from "./item/item.vue";

const routes = [
  {
    path: "/orderPosition",
    component: AppOrderpositionsIndex,
    meta: {
      auth: {
        roles: "orderPosition.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "orderPosition.index",
        component: AppOrderpositionsList,
        meta: {
          auth: {
            roles: "orderPosition.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "orderPosition.create",
        component: AppOrderpositionsItem,
        meta: {
          auth: {
            roles: "orderPosition.create",
            redirect: { name: "orderPosition.index" }
          }
        }
      },
      {
        path: ":id",
        name: "orderPosition.edit",
        component: AppOrderpositionsItem,
        meta: {
          auth: {
            roles: "orderPosition.update",
            redirect: { name: "orderPosition.index" }
          }
        }
      }
    ]
  }
];

export default routes;
